import { useState } from 'react'
import {
    Container,
    HeaderBar,
    TypoGraph,
    Card,
  } from 'components'
import styles from './summaryReport.module.scss'
import strings from 'strings'
import { useGridApiRef } from '@mui/x-data-grid'
import { Button, Grid, Chip } from '@mui/material'
import ScrollToTopCornerButton from 'components/scrollToTopButton'
import CarrierHeaderKPIs from './partial/headerKPIs/index'
import SummaryRadiusOfOperation from './partial/summaryRadiusOfOperation'
import ActiveUnits from './partial/activeUnits'
import EstimatedMiles from './partial/estimatedMilesTotal'

const t = strings.CARRIERS
const e = strings.CSV_EXPORT

interface ICarrierSummaryReport {
    print?: boolean
}

const CarrierSummaryReport: React.FC<ICarrierSummaryReport> = (props) => {
    const { print } = props
    const [loading, setLoading] = useState(false)
    const [showExportPdfButton, setShowExportPdfButton] = useState(false)
    const apiRef = useGridApiRef()

    const HeaderDom = () => {
        return (
            <Container className={styles.headerContainer}>
                <Container className={styles.headerTitleContainer}>
                    <TypoGraph
                        variant="h1"
                        sx={{ marginRight: '1rem' }}
                        mb={0}
                        content={'Carrier Summary Report'}
                    />
                    <Chip 
                        label="BETA" 
                        color="primary" 
                        size="small"
                        sx={{ 
                            height: '24px',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                            color: 'white'
                        }}
                    />
                </Container>
                {showExportPdfButton && (
                    <Button variant="contained" color="info">
                        Export to PDF
                    </Button>
                )}
            </Container>
        )
    }

    return (
        <Container className={styles.summaryReportBladeBodyContainer}>
            <Container>
                <HeaderBar dom={<HeaderDom />} />
                {/* Header KPIs */}
                <CarrierHeaderKPIs />
                {/* Estimated Miles - Total */}
                <EstimatedMiles/>
                {/* Radius of Operation */}
                <SummaryRadiusOfOperation />
                {/* Recent Crashes - Last 90 Days */}
                <></>
                {/* Speeding Analysis */}
                <></>
                {/* Safety Analysis */}
                <></>
                {/* Highest Rated Units (Best Performers) */}
                <></>
                {/* Time-Based Analysis */}
                <></>
                {/* New Unit Added - Last 90 Days */}
                <></>
                {/* Active Units - Past 90 Days */}
                <ActiveUnits/>
                {/* Inactive Vehicles */}
                <></>
            </Container>

            <ScrollToTopCornerButton />
        </Container>
    )
}

export default CarrierSummaryReport